import { Button, ESectionColor, Section } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { useDispatch } from 'react-redux';
import { Dispatch, Action } from 'redux';
import { AssetsBaseUrl } from '../../assets';
import { EExerciseView } from '../constants';
import { backFromNotImplementedScreen } from '../firebaseActions';
import { ExerciseActions } from '../slice';
import './NotImplementedModePage.scss';

export default function NotImplementedModePage() {
  const { t } = useTranslation();

  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const imgSrc = `${AssetsBaseUrl}/feature/extra-modes/NotImplemented.svg`;
  const title = t(`Exercise.ExtraModes.NotImplemented.Title`);
  const descriptionText = t(`Exercise.ExtraModes.NotImplemented.Description`);
  const descriptionContent = descriptionText.split('\n').map((line, index) => <p key={index}>{line}</p>);
  const buttonLabel = t(`Exercise.ExtraModes.NotImplemented.Action`);
  const buttonActionHandler = () => {
    dispatch(backFromNotImplementedScreen());
    dispatch(ExerciseActions.changeView(EExerciseView.Intro));
  };
  return (
    <Section noPadding={true} color={ESectionColor.blue} className="exercise-section">
      <div className="view not-implemented">
        <div>
          <h3>{title}</h3>
          {descriptionContent}
          <Button label={buttonLabel} onClick={buttonActionHandler} />
        </div>
        <div>
          <img src={imgSrc} alt={title} />
        </div>
      </div>
    </Section>
  );
}
